
import {onMounted, ref} from 'vue';
import HotspotPopup from './hotspotPopup.vue';
import {GetHotspotBenefits, GetHotspotItems} from 'Apis/apis';
import Swiper, {Navigation} from 'swiper';
Swiper.use([Navigation]);

export default {
	name: 'HotspotMobile',
	components: {
		HotspotPopup,
	},
	setup() {
		const hotspotItems = ref([]);
		const prevButton = ref(null);
		const nextButton = ref(null);
		const mobileHotspot = ref(null);
		const contentItems = ref([]);
		const itemTitle = ref('');
		const itemDescription = ref('');
		const hotspotsLoading = ref(true);
		const fallbackImage = ref('/ResourcePackages/RoyalPrestige/assets/src/project/images/Misc/noimage.jpg');
		let hotspotId = document.querySelector('.hotspot').getAttribute('data-hotspotId') ? document.querySelector('.hotspot').getAttribute('data-hotspotId') : "";
		
		const title = ref({});
		let titleLn = document.querySelector('.hotspot').getAttribute('data-title').length == 0 ? 0 : document.querySelector('.hotspot').getAttribute('data-title').length;

		async function getBenefits(id) {
			let benefit = await GetHotspotBenefits(id);
			if (benefit.value.length) {
				contentItems.value.push({
					id: id,
					title: benefit.value[0].DisplayTitle,
					description: benefit.value[0].Description
				});
			}

			setupSwiper();
			hotspotsLoading.value = false;
		}

		let setupSwiper = () => {
			let mySwiper = new Swiper(mobileHotspot.value, {
				slidesPerView: 1,
				spaceBetween: 0,
				navigation: {
					nextEl: nextButton.value,
					prevEl: prevButton.value,
				}
			});
		};

		async function getHotspotItems(hotspotId) {
			const items = await GetHotspotItems(hotspotId);
			if (items.value) {
				hotspotItems.value = await items.value.map(item => ({...item, visible: false}));
			}

			if(await hotspotItems.value.length) {
				hotspotItems.value.forEach((hotspotItem) => {
					getBenefits(hotspotItem.Id)
				});
			}
		}

		let getItemTitle = (item) => {
			return contentItems.value.filter(e => e.id === item.Id).length ? contentItems.value.filter(e => e.id === item.Id)[0].title : "";
		}

		let getItemDescription = (item) => {
			return contentItems.value.filter(e => e.id === item.Id).length ? contentItems.value.filter(e => e.id === item.Id)[0].description : "";
		}

		onMounted(() => {
			const titleEl = document.querySelector('.hotspot');
			const titleValue = titleEl.getAttribute('data-title');
			if (titleEl && titleValue) {
				title.value = titleValue;
			}
			getHotspotItems(hotspotId);

		});

		return {
			hotspotId,
			hotspotItems,
			fallbackImage,
			itemTitle,
			itemDescription,
			mobileHotspot,
			hotspotsLoading,
			prevButton,
			nextButton,
			getItemTitle,
			getItemDescription,
			title,
			titleLn
		};
	},
};
